import React from 'react'

import { Step, Box, Grid } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'
import TranslationSection from './Section/Translation'
import SettingSection from './Section/Setting'

const VehicleTypeDetails = props =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={3}>
      <Grid size={12}><FormHeader goBackPath={'/vehicletype'} /></Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[2]} activeStep={0} orientation={'vertical'}>
          <Step> <TranslationSection /> </Step>
          <Step> <SettingSection /> </Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(VehicleTypeDetails)
